import React from 'react';
import { Button, Segment, Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import DraggableButtons from './DraggableButtons';
import { EXPORT_ITEMS_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components';
import { ImportExportItemsEnum } from 'Common/FieldEnum';
import {
  ImportExportTypeOptionsEnum,
  DroppableAreaEnum,
} from 'Common/Constants/Enumeration/ImportExportInventoryEnum';
import { InputField, SelectField, CheckboxField } from 'Common/SemanticWrapper';
import {
  importExportTypeOptions,
  yesNoOptions,
} from './../../../helper/importExport';

const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? '#DFEFF9' : '',
  padding: 8,
  width: '100%',
  height: '100%',
});

export const ExportItemsComponent = props => {
  const {
    exportType,
    loadPreviousOptionsDropDown,
    handleSubmit,
    allChipsData,
    selectedChipsData,
    onItemClick,
    onDragEnd,
    addAll,
    removeAll,
    handleToBeExportedFields,
    handleExportTypeChange,
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Grid>
        <Grid.Row className="row--compressed" columns={2}>
          <Grid.Column>
            <TitledCard title={'Step 1'} className="export-title-card">
              <Grid style={{ minHeight: 200 }}>
                <Grid.Row>
                  <Grid.Column>
                    <div>
                      <label>What Type of export is this?</label>
                      <ReduxFormButtonGroup
                        options={importExportTypeOptions}
                        type={'button'}
                        formName={EXPORT_ITEMS_FORM_NAME}
                        fieldName={ImportExportItemsEnum.Type}
                        onChange={handleExportTypeChange}
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    {exportType ===
                      ImportExportTypeOptionsEnum.LoadPreviouslySaved && (
                      <Field
                        name={ImportExportItemsEnum.LoadPrevious}
                        component={SelectField}
                        type={'text'}
                        options={loadPreviousOptionsDropDown}
                        label={'Please select a saved configuration'}
                        onChange={handleToBeExportedFields}
                      />
                    )}
                    {exportType === ImportExportTypeOptionsEnum.New && (
                      <Field
                        name={ImportExportItemsEnum.Name}
                        component={InputField}
                        type={'text'}
                        label={'Name of configuration to be saved'}
                      />
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>
          </Grid.Column>
          <Grid.Column>
            <TitledCard title={'Step 2'} className="export-title-card">
              <Grid style={{ minHeight: 200 }}>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <div>
                      <label>Should the first row be field headers?</label>
                      <ReduxFormButtonGroup
                        options={yesNoOptions}
                        type={'button'}
                        formName={EXPORT_ITEMS_FORM_NAME}
                        fieldName={ImportExportItemsEnum.IncludeHeaders}
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <span>
                      <Field
                        name={ImportExportItemsEnum.Delimiter}
                        component={InputField}
                        type={'text'}
                        label={'Please enter a field separator'}
                      />
                    </span>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Field
                      name={ImportExportItemsEnum.IncludeWOCurrentBidPrice}
                      component={CheckboxField}
                      label={'Include items without a current bid price '}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <TitledCard title={'Step 3'}>
              <Grid>
                <Grid.Row columns={4} style={{ marginBottom: '10px' }}>
                  <Grid.Column>
                    <span>All Item Fields</span>
                  </Grid.Column>
                  <Grid.Column>
                    <Button className="float-right" onClick={addAll} type={'button'}>
                      Add All
                    </Button>
                  </Grid.Column>
                  <Grid.Column>
                    <span>
                      Item Fields to be exported(Drag Up/Down to reorder the
                      fields)
                    </span>
                  </Grid.Column>
                  <Grid.Column floted={'right'}>
                    <Button className="float-right" onClick={removeAll} type={'button'}>
                      Remove All
                    </Button>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={1}>
                  <Grid.Column>
                    <div className="drag-drop-context-container">
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Segment className="non-selected-item">
                          <Droppable droppableId={DroppableAreaEnum.Selected}>
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                                {...provided.droppableProps}
                              >
                                <DraggableButtons
                                  items={allChipsData}
                                  clickHandler={onItemClick}
                                />
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </Segment>
                        <Segment className="selected-item">
                          <Droppable
                            droppableId={DroppableAreaEnum.NonSelected}
                          >
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                                {...provided.droppableProps}
                              >
                                <DraggableButtons
                                  items={selectedChipsData}
                                  clickHandler={onItemClick}
                                  showSelected
                                />
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </Segment>
                      </DragDropContext>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </form>
  );
};
ExportItemsComponent.propTypes = {
  exportType: PropTypes.number,
  loadPreviousOptionsDropDown: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func,
  allChipsData: PropTypes.array,
  selectedChipsData: PropTypes.array,
  onItemClick: PropTypes.func,
  onDragEnd: PropTypes.func,
  addAll: PropTypes.func,
  removeAll: PropTypes.func,
  handleToBeExportedFields: PropTypes.func,
  handleExportTypeChange: PropTypes.func,
};
export default ExportItemsComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/importexport/exportInventory/components/ExportItems.js